<Div class="bg-white sticky-top">
  <nav class="py-1 bg-dark no-print">
    <div class="container d-flex">
      <ul class="nav ms-auto">
        <li class="nav-item">
          <div class="d-flex" style="vertical-align: middle">
            <label id="WelcomeLable">{{ welcomeLabel }} </label>
            &nbsp; &nbsp;
            <button
              class="btn btn-outline-light nav-link px-sm-2"
              (click)="logInOut()"
              style="padding: 0"
            >
              {{ buttonText }}
            </button>
          </div>
        </li>
      </ul>
    </div>
  </nav>
  <div class="container">
    <div>
      <p-menubar [model]="menuItems">
        <ng-template pTemplate="start">
          <img
            class="justify-content-left"
            type="image/svg+xml"
            [src]="logoPath"
            alt="Your browser does not support SVGs"
            [style]="this.logoStyle"
          />
        </ng-template>
        <ng-template pTemplate="end">
          <img
            type="image/svg+xml"
            src="assets/svg/dfs-logo-dark.svg"
            alt="Your browser does not support SVGs"
          />
        </ng-template>
      </p-menubar>
    </div>
  </div>
</Div>
